import React, { useState, useEffect } from "react";
import moment from "moment";

const EMRPreview = ({
  showQRCode,
  selectedTemplate,
  showSignature,
  patientDetails,
  margins,
  fontSize,
  headerType,
  headerData,
  headerLayout,
  uploadedHeaderImage,
}) => {
  const fontSizeMap = {
    small: "8px",
    regular: "10px",
    medium: "12px",
    large: "14px",
  };

  const medications = [
    {
      medicine: "Paracetamol",
      dosage: "500mg",
      frequency: "1-0-1",
      duration: "5 days",
      instructions: "Take after meals",
    },
    {
      medicine: "Ibuprofen",
      dosage: "400mg",
      frequency: "1-0-1",
      duration: "3 days",
      instructions: "Take with food",
    },
  ];

  const vitals = [
    { name: "BP", value: "120/80", unit: "mmHg" },
    { name: "Temp", value: "98.6", unit: "°F" },
  ];

  const symptoms = [{ label: "Headache" }, { label: "Fever" }];

  const investigations = [
    { label: "Complete Blood Count (CBC)" },
    { label: "Liver Function Test (LFT)" },
  ];

  const doctorData = {
    first_name: "Dr. Rajesh",
    last_name: "Patel",
    doctor_qualification: "MBBS, MD",
    doctor_speciality: "General Physician",
  };

  const clinicDetails = {
    address: "456 Main St, Mumbai, India",
  };

  const [clinicLogoBase64, setClinicLogoBase64] = useState("");
  const followUpDate = new Date();

  const symptomsString = symptoms.map((symptom) => symptom.label).join(" | ");
  const investigationsString = investigations
    .map((investigation) => investigation.label)
    .join(" | ");
  const vitalsString = vitals
    .map((vital) => `${vital.name}: ${vital.value} ${vital.unit}`)
    .join(" | ");

  /*
For layout1, the logo is rendered on the left, followed by the clinic name and address on the left, and the doctor details on the right.
For layout2, the doctor details are rendered on the left, and the clinic name and address are rendered on the right, followed by the logo.
For layout3, the doctor details are rendered on the left, the logo is centered, and the clinic details are rendered on the right.
For layout4, the clinic name and address are rendered on the left, and the doctor details are rendered on the right. No logo is displayed.
    */

  const renderHeader = () => {
    if (selectedTemplate === "letterhead") {
      return null;
    }

    if (headerType === "upload" && uploadedHeaderImage) {
      const headerImageUrl = URL.createObjectURL(
        new Blob([uploadedHeaderImage], { type: "image/png" })
      );
      return (
        <img
          src={headerImageUrl}
          alt="Uploaded Header"
          style={{ width: "100%", height: "auto" }}
        />
      );
    }

    if (headerLayout === "layout1") {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10mm",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {headerData.clinicLogo ? (
              <img
                src={URL.createObjectURL(
                  new Blob([headerData.clinicLogo], { type: "image/png" })
                )}
                alt="Clinic Logo"
                style={{
                  maxWidth: "100px",
                  maxHeight: "50px",
                  objectFit: "contain",
                  marginRight: "10px",
                }}
              />
            ) : null}
            <div>
              <h2 style={{ fontSize: "16px", marginBottom: "5px" }}>
                {headerData.clinicName}
              </h2>
              <p style={{ margin: 0 }}>{headerData.clinicAddress}</p>
              <p style={{ margin: 0 }}>Contact: {headerData.clinicContact}</p>
            </div>
          </div>
          <div>
            <h1 style={{ fontSize: "18px", marginBottom: "5px" }}>
              Dr. {headerData.doctorName}
            </h1>
            <p style={{ margin: 0 }}>{headerData.degree}</p>
            <p style={{ margin: 0 }}>MRN: {headerData.mrnNo}</p>
          </div>
        </div>
      );
    } else if (headerLayout === "layout2") {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10mm",
          }}
        >
          <div>
            <h1 style={{ fontSize: "18px", marginBottom: "5px" }}>
              Dr. {headerData.doctorName}
            </h1>
            <p style={{ margin: 0 }}>{headerData.degree}</p>
            <p style={{ margin: 0 }}>MRN: {headerData.mrnNo}</p>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ textAlign: "right", marginRight: "10px" }}>
              <h2 style={{ fontSize: "16px", marginBottom: "5px" }}>
                {headerData.clinicName}
              </h2>
              <p style={{ margin: 0 }}>{headerData.clinicAddress}</p>
              <p style={{ margin: 0 }}>Contact: {headerData.clinicContact}</p>
            </div>
            {headerData.clinicLogo ? (
              <img
                src={URL.createObjectURL(
                  new Blob([headerData.clinicLogo], { type: "image/png" })
                )}
                alt="Clinic Logo"
                style={{
                  maxWidth: "100px",
                  maxHeight: "50px",
                  objectFit: "contain",
                  marginRight: "10px",
                }}
              />
            ) : null}
          </div>
        </div>
      );
    } else if (headerLayout === "layout3") {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10mm",
          }}
        >
          <div>
            <h1 style={{ fontSize: "18px", marginBottom: "5px" }}>
              Dr. {headerData.doctorName}
            </h1>
            <p style={{ margin: 0 }}>{headerData.degree}</p>
            <p style={{ margin: 0 }}>MRN: {headerData.mrnNo}</p>
          </div>
          <div style={{ textAlign: "center" }}>
            {headerData.clinicLogo ? (
              <img
                src={URL.createObjectURL(
                  new Blob([headerData.clinicLogo], { type: "image/png" })
                )}
                alt="Clinic Logo"
                style={{
                  maxWidth: "100px",
                  maxHeight: "50px",
                  objectFit: "contain",
                  marginRight: "10px",
                }}
              />
            ) : null}
          </div>
          <div style={{ textAlign: "right" }}>
            <h2 style={{ fontSize: "16px", marginBottom: "5px" }}>
              {headerData.clinicName}
            </h2>
            <p style={{ margin: 0 }}>{headerData.clinicAddress}</p>
            <p style={{ margin: 0 }}>Contact: {headerData.clinicContact}</p>
          </div>
        </div>
      );
    } else if (headerLayout === "layout4") {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10mm",
          }}
        >
          <div>
            <h2 style={{ fontSize: "16px", marginBottom: "5px" }}>
              {headerData.clinicName}
            </h2>
            <p style={{ margin: 0 }}>{headerData.clinicAddress}</p>
            <p style={{ margin: 0 }}>Contact: {headerData.clinicContact}</p>
          </div>
          <div>
            <h1 style={{ fontSize: "18px", marginBottom: "5px" }}>
              Dr. {headerData.doctorName}
            </h1>
            <p style={{ margin: 0 }}>{headerData.degree}</p>
            <p style={{ margin: 0 }}>MRN: {headerData.mrnNo}</p>
          </div>
        </div>
      );
    }
  };

  return (
    <div
      id="pdf-content"
      style={{
        fontSize: fontSizeMap[fontSize],
        fontFamily: "Arial, sans-serif",
        width: "210mm",
        height: "297mm",
        border: "1px solid #ccc",
        borderRadius: selectedTemplate === "default" ? "0" : "10px",
        padding: `${margins.top}cm ${margins.right}cm ${margins.bottom}cm ${margins.left}cm`,
        boxSizing: "border-box",
        backgroundColor: selectedTemplate === "default" ? "#fff" : "#f9f9f9",
        overflow: "hidden",
      }}
    >
      {renderHeader()}

      <div style={{ padding: "15mm", boxSizing: "border-box", height: "100%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "5mm",
          }}
        >
          <div>
            <p style={{ margin: "0" }}>
              <strong>Patient:</strong>{" "}
              {patientDetails.name ? patientDetails.name : ""}
              {patientDetails.gender && <span>, {patientDetails.gender}</span>}
              {patientDetails.age && (
                <span>, {patientDetails.age} years old</span>
              )}
            </p>
            {patientDetails.phone && (
              <p style={{ margin: "0" }}>
                <strong>Phone:</strong> {patientDetails.phone}
              </p>
            )}
            {patientDetails.id && (
              <p style={{ margin: "0" }}>
                <strong>ID:</strong> {patientDetails.id}
              </p>
            )}
          </div>
          {patientDetails.appointmentDate && (
            <div style={{ textAlign: "right" }}>
              <p style={{ margin: "0" }}>
                <strong>Date:</strong>{" "}
                {moment(patientDetails.appointmentDate).format("DD/MMM/YYYY")}
              </p>
            </div>
          )}
        </div>
        {followUpDate && (
          <div style={{ textAlign: "right", marginBottom: "5mm" }}>
            <p style={{ margin: "0" }}>
              <strong>Follow-up Date:</strong>{" "}
              {moment(followUpDate).format("DD-MMM-YYYY")}
            </p>
          </div>
        )}

        <hr style={{ borderTop: "1px solid #000", marginBottom: "5mm" }} />
        <h2
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            textDecoration: "underline",
            marginBottom: "3mm",
          }}
        >
          Consultation Summary
        </h2>
        <p style={{ marginBottom: "5mm" }}>SYMPTOMS: {symptomsString}</p>
        <h2
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            textDecoration: "underline",
            marginBottom: "3mm",
          }}
        >
          Prescription
        </h2>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "5mm",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "2mm",
                  backgroundColor: "#f2f2f2",
                }}
              >
                Medicine
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "2mm",
                  backgroundColor: "#f2f2f2",
                }}
              >
                Dose
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "2mm",
                  backgroundColor: "#f2f2f2",
                }}
              >
                Frequency
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "2mm",
                  backgroundColor: "#f2f2f2",
                }}
              >
                Duration
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "2mm",
                  backgroundColor: "#f2f2f2",
                }}
              >
                Remarks
              </th>
            </tr>
          </thead>
          <tbody>
            {medications.map((med, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid #000", padding: "2mm" }}>
                  {med.medicine}
                </td>
                <td style={{ border: "1px solid #000", padding: "2mm" }}>
                  {med.dosage}
                </td>
                <td style={{ border: "1px solid #000", padding: "2mm" }}>
                  {med.frequency}
                </td>
                <td style={{ border: "1px solid #000", padding: "2mm" }}>
                  {med.duration}
                </td>
                <td style={{ border: "1px solid #000", padding: "2mm" }}>
                  {med.instructions}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <h2
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            textDecoration: "underline",
            marginBottom: "3mm",
          }}
        >
          Investigations
        </h2>
        <p style={{ marginBottom: "5mm" }}>{investigationsString}</p>
        <h2
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            textDecoration: "underline",
            marginBottom: "3mm",
          }}
        >
          Vitals:
        </h2>
        <p>{vitalsString}</p>
        {showQRCode && (
          <div style={{ textAlign: "right", marginTop: "10mm" }}>
            <img
              src="path/to/qr-code.png"
              alt="QR Code"
              style={{ width: "40mm", height: "40mm" }}
            />
          </div>
        )}
        {showSignature && (
          <div style={{ textAlign: "right", marginTop: "10mm" }}>
            <img
              src="path/to/signature.png"
              alt="Signature"
              style={{ width: "60mm", height: "20mm" }}
            />
            <p style={{ margin: "2mm 0 0" }}>
              <strong>{headerData.doctorName}</strong>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EMRPreview;
